import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import { environment } from '@environments/environment';
/***
 * This is a place holder for checking logged in, reauth, etc while waiting on the real thing
 */
@Injectable()
export class DevAuthService {
  serviceLibrary: ServiceLibrary;

  public constructor(servLib: ServiceLibrary){
    this.serviceLibrary = servLib;
  }

  DoIWork(parameters: Dictionary): Observable<ServiceReturn> {
    const versionToUse = '/v1';
    let serviceUrl = '/api/Dev/DoIWork';
    if  (environment.skipAPIVersioning !== undefined && !environment.skipAPIVersioning) {
      serviceUrl = versionToUse + serviceUrl;
    }

    return this.serviceLibrary.HttpGet(serviceUrl, ServiceLibrary.ContentType.JSON, parameters);
  }

  RollingAuthCheck(parameters: Dictionary): Observable<ServiceReturn> {
    const versionToUse = '/v1';
    let serviceUrl = '/api/Dev/RollingAuthCheck';
    if  (!environment.skipAPIVersioning !== undefined && !environment.skipAPIVersioning) {
      serviceUrl = versionToUse + serviceUrl;
    }

    return this.serviceLibrary.HttpGet(serviceUrl, ServiceLibrary.ContentType.JSON, parameters);
  }
}
